import { ErrorTranslations } from "./models/error-translaction-model";
import { SupportedLanguages } from "@/lang/lang-settings";
import { ptBR } from "./translactions/pt-BR"
import { enUS } from "./translactions/en-US"

export const error: Record<SupportedLanguages, ErrorTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
